import { UserGamesHttpService } from '@profile/infra';
import { inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { map, Observable, switchMap } from 'rxjs';
import { formatDate, GameDetailsModel, mapHost, mapLocation } from '@core';
import { GetUserGamesPathParams, GetUserGamesResponse, UserGameDto } from '@core-http';

export class GetUserLastGamesQueryHandler {
  private readonly userGamesHttpService: UserGamesHttpService = inject(UserGamesHttpService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  getLastGames(): Observable<GameDetailsModel[]> {
    return this.activatedRoute.params.pipe(
      switchMap((params: Params) => {
        const pathParams: GetUserGamesPathParams = { userId: params['id'] };
        return this.userGamesHttpService.getLastGames(pathParams);
      }),
      map((data: GetUserGamesResponse) => data?.pastGames?.map((game: UserGameDto) => this.mapUserGameDto(game)))
    );
  }

  private mapUserGameDto(game: UserGameDto): GameDetailsModel {
    return {
      gameName: game.name,
      gameId: game.gameId,
      gameDateStart: game.gameDateStart,
      formattedDate: formatDate(game.gameDateStart, game.gameDateEnd),
      level: game.level,
      location: mapLocation(game.location),
      host: mapHost(game.host),
      locationType: game.locationType
    };
  }
}
